import PropTypes from 'prop-types';

const DataTableFilterLabel = ({ label = '' }) => {
  return (
    <span style={{ fontSize: 'small', whiteSpace: 'nowrap' }}>{label}</span>
  );
};

DataTableFilterLabel.propTypes = {
  label: PropTypes.string,
};

export default DataTableFilterLabel;
